import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const TeamRecordState = {
  records: [],
  restrictedRecords: [],
}

export const TeamRecordActions = {
  getTeamRecords: async ({ commit }, teamId) => {
    return axiosRequest.
      get(`/teams/${teamId}/records`).
      then(({ data }) => {
        commit('setTeamRecords', data)
        return data
      }).
      catch(handleError)
  },

  excludeRecord: async (_, { teamId, recordId }) => {
    return axiosRequest.
      delete(`/teams/${teamId}/records/${recordId}`).
      then(({ data }) => {
        return data
      }).
      catch(handleError)
  },

  getRestrictedRecords: async ({ commit }, teamId) => {
    return axiosRequest.
      get(`/teams/${teamId}/restricted_resources/records`).
      then(({ data }) => {
        commit('setRestrictedRecords', data)
        return data
      }).
      catch(handleError)
  },

  permitRecord: async (_, { teamId, recordId }) => {
    return axiosRequest.
      post(`/teams/${teamId}/records/${recordId}/permit`).
      then(({ data }) => {
        return data
      }).
      catch(handleError)
  },
}

export const TeamRecordGetters = {
  teamRecords: state => state.records || [],

  restrictedRecords: state => (state.restrictedRecords || []).map(record => ({
    ...record,
    type: 'Record',
  })),
}

export const TeamRecordMutations = {
  setTeamRecords: (state, records) => (state.records = records),

  setRestrictedRecords: (state, records) => (state.restrictedRecords = records),
}
